import { BrowserDocumentOpener } from '@/infra/adapters/browser-document-opener/browser-document-opener'
import { RemoteOpenLeaseReceipt } from '@/data/usecases'
import { makeAxiosHttpClient } from '@/main/factories/http'
import { OpenLeaseReceipt } from '@/domain/usecases'
import env from '@/main/config/env'

export const makeOpenLeaseReceipt = (): OpenLeaseReceipt => {
  const url = env.API_URL
  const httpClient = makeAxiosHttpClient<string>()

  return new RemoteOpenLeaseReceipt(url, httpClient, new BrowserDocumentOpener())
}
